import type { MaxCartLimitable } from '@iheartjane/types';

import type { ProductMaxCartQuantityOptions } from '@jane/bloom/viewModels/productDetail';
import type { Cart } from '@jane/bloom/viewModels/schemas/checkout';

interface GetMaxCartQuantityArgs {
  cart?: Cart;
  currentProduct: MaxCartLimitable & { product_id: number };
  currentWeight: string | undefined;
  /** When false, returns the total allowed quantity instead of remaining. Defaults to true. */
  remaining?: boolean;
  storeId?: number;
}

/**
 * @returns the max quantity of a product allowed in the cart.
 * By default returns the *remaining* quantity (total minus what's already in
 * the cart). Pass `remaining: false` to get the absolute total.
 */
export const getMaxCartQuantity = ({
  cart,
  currentProduct,
  currentWeight,
  remaining = true,
  storeId,
}: GetMaxCartQuantityArgs): number => {
  let filter = 'max_cart_quantity';
  let priceId = 'each';

  if (currentWeight) {
    priceId = currentWeight.replace(' ', '_');
    filter = `max_cart_quantity_${priceId}`;
  }

  const maxProductQty = currentProduct[filter as ProductMaxCartQuantityOptions];

  if (!remaining) return maxProductQty;

  const existingCartProduct =
    cart?.storeId === storeId &&
    cart?.items.find(
      (item) =>
        item.productId === currentProduct.product_id && item.priceId === priceId
    );
  return existingCartProduct
    ? maxProductQty - existingCartProduct.count
    : maxProductQty;
};
